module.exports = __webpack_public_path__ + "static/brands-bb72145a986de82f9167812eee4c37e2.png";